import { useEffect, useMemo, useState } from "react";
import { useInView } from "react-intersection-observer";

function MultipleObserver(props: { content: React.JSX.Element; onVisible: () => any, }) {
    const { onVisible, content } = props;

    const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: false, initialInView: false });

    useEffect(() => {
        if (inView) {
            onVisible()
        }
    }, [inView])

    return <tr ref={ref}>
        {content}
    </tr>
}

interface TableObservedProps<T> {
    tableData: T[],
    rowFunction: (index: number, row: T) => JSX.Element,
    onRowClick?: (row: T) => void
    rowsCount: number,
    rowsIncrement: number,
}

export default function TableObserved<T>(props: TableObservedProps<T>) {
    const { tableData, rowFunction, onRowClick, rowsCount, rowsIncrement } = props;

    const ROWS_MAX_COUNT = rowsCount
    const ROWS_INCREMENT = rowsIncrement

    const [limit, setLimit] = useState(ROWS_MAX_COUNT)

    const data = useMemo((() => {
        const elements = []
        for (let index = 0; index < tableData.length; index++) {
            if (index < limit - ROWS_MAX_COUNT || index > limit) {
                continue
            }

            const row = tableData[index]
            elements.push(<>
                {index == limit
                    ? <MultipleObserver
                        content={<></>}
                        onVisible={function () {
                            setLimit((prev) => prev + ROWS_INCREMENT)
                            // non react way but fuck it
                            setTimeout(() => { document.getElementById(`rows_${index}`)?.scrollIntoView() })
                        }} />
                    : <></>
                }
                {index == limit - ROWS_MAX_COUNT && index != 0
                    ? <MultipleObserver
                        content={<></>}
                        onVisible={function () {
                            setLimit((prev) => {
                                return prev - ROWS_INCREMENT < ROWS_MAX_COUNT ? ROWS_MAX_COUNT : prev - ROWS_INCREMENT
                            })
                            // non react way but fuck it
                            setTimeout(() => { document.getElementById(`rows_${index}`)?.scrollIntoView() })
                        }} />
                    : <></>
                }
                <tr id={`rows_${index}`} style={{ whiteSpace: "nowrap" }} onClick={() => { if (onRowClick != null) { onRowClick(row) } }}>
                    {rowFunction(index, row)}
                </tr>
            </>)
        }
        return elements
    }), [limit, tableData])

    useEffect(() => {
        setLimit(ROWS_MAX_COUNT)
    }, [tableData])

    return data.map((val) => { return val })
}